import { QuoteDetail } from 'quote-detail/quote-detail';
import { useQuote } from 'shared/queries';
import { Brands, UserInfo } from 'shared/types';

interface QuoteResolverProps {
  brand: Brands;
  id: string;
  user: UserInfo;
}
export function QuoteResolver({ brand, id, user }: QuoteResolverProps) {
  const { data, isFetching } = useQuote(id, brand);
  if (!data) {
    return null;
  }
  return <QuoteDetail quote={data} user={user} brand={brand} id={id} isLoading={isFetching} />;
}
